import { FC, PropsWithChildren } from 'react';
import { useInitializeFilteredStores, useInitializeLookupTables } from './hooks';
import { useInitializeIsHistorical } from './hooks/initializers/useInitializeIsHistorical';

/**
 * Initialize global state
 */
const Initializer: FC<PropsWithChildren<unknown>> = ({ children }) => {
    useInitializeIsHistorical();
    useInitializeLookupTables();
    useInitializeFilteredStores();
    return <>{children}</>;
};

export default Initializer;
